<template>
  <div>
    <!-- <div class="container"> -->
    <van-nav-bar fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon color="white" name="arrow-left" size="18" />
      </template>
      <template #title>
        <span style="color: #ffffff">我的报修</span>
      </template>
    </van-nav-bar>

    <van-pull-refresh
      class="container"
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <div class="nav-placeholder"></div>
      <div class="tips_null" v-if="initData.repairList.length <= 0">
        没有更多了
      </div>
      <div>
        <div
          class="msg-item"
          v-for="(reqair, index) in initData.repairList"
          :key="'repair' + index"
        >
          <div class="msg-item-box">
            <van-cell
              title-class="msg-item-room"
              class="msg-item-head"
              :title="
                reqair.maintainName
                  ? reqair.maintainName + '【维修员】'
                  : '未处理'
              "
            >
              <template #default>
                <van-tag
                  class="tag"
                  size="medium"
                  :color="showRepairsStatus(reqair.repairsStatus)"
                  >{{ showRepairsStatusName(reqair.repairsStatus) }}</van-tag
                >
              </template>
            </van-cell>
            <div class="msg-item-body">
              <div
                v-if="reqair.maintainTel"
                class="msg-item-body-phenomenon van-ellipsis"
              >
                维修电话：{{ reqair.maintainTel }}（<a
                  class="phone"
                  :href="'tel:' + reqair.maintainTel"
                  >呼叫</a
                >）
              </div>
              <div class="msg-item-body-q">
                <span class="msg-item-body-q-left">问题现象：</span
                ><span class="msg-item-body-q-right">{{
                  showRepairsMalfunctionType(reqair.malfunctionType)
                }}</span>
              </div>
              <div class="msg-item-body-question van-ellipsis">
                问题描述：{{ reqair.repairsDesc }}
              </div>
              <div class="msg-item-body-date van-ellipsis">
                申报时间：{{ reqair.repairsTime }}
              </div>
              <div
                v-show="reqair.conditions === 1"
                class="msg-item-body-date van-ellipsis"
              >
                故障等级：<span style="color: red">加急</span>
              </div>
              <span v-if="reqair.repairsStatus === 3">
                <div v-if="reqair.evaluate.commentTime">
                  <div class="msg-item-body-date van-ellipsis">
                    <span v-html="'评\u3000\u3000分：'"></span
                    ><van-rate
                      size="19"
                      readonly
                      v-model="reqair.evaluate.starLevel"
                    />
                  </div>
                </div>
                <span v-else>
                  <span
                    @click="
                      toRepairDetail(
                        reqair.repairsId,
                        reqair.roomAddress,
                        showRepairsMalfunctionType(reqair.malfunctionType),
                        reqair.repairsTime,
                        '9'
                      )
                    "
                    class="msg-item-body-btn"
                  >
                    <van-button plain hairline size="mini" type="info"
                      >&#160;&#160;评论</van-button
                    >
                  </span>

                  <span
                    @click="
                      toRepairDetail(
                        reqair.repairsId,
                        reqair.roomAddress,
                        showRepairsMalfunctionType(reqair.malfunctionType),
                        reqair.repairsTime,
                        '4'
                      )
                    "
                    class="msg-item-body-btn"
                  >
                    <van-button plain hairline size="mini" type="danger"
                      >&#160;&#160;驳回</van-button
                    >
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <!-- </div> -->
  </div>
</template>

<script>
import { Toast } from "vant";
import dayjs from "dayjs";
export default {
  name: "RepairList",
  data() {
    return {
      statuColors: [
        { type: "#ff976a", name: "待维修" },
        { type: "#1989fa", name: "维修中" },
        { type: "#07c160", name: "已维修" },
        { type: "#FF0000", name: "驳回" },
        { type: "#C0C0C0", name: "已完成" },
      ],
      initData: {
        repairList: [],
      },
      isLoading: false,
    };
  },
  computed: {
    showRepairsStatus(repairsStatus) {
      return function (repairsStatus) {
        switch (repairsStatus) {
          case 1:
            return this.statuColors[0].type;
            break;
          case 2:
            return this.statuColors[1].type;
            break;
          case 3:
            return this.statuColors[2].type;
            break;
          case 4:
            return this.statuColors[3].type;
            break;
          case 9:
            return this.statuColors[4].type;
            break;
        }
      };
    },
    showRepairsStatusName(repairsStatus) {
      return function (repairsStatus) {
        switch (repairsStatus) {
          case 1:
            return this.statuColors[0].name;
            break;
          case 2:
            return this.statuColors[1].name;
            break;
          case 3:
            return this.statuColors[2].name;
            break;
          case 4:
            return this.statuColors[3].name;
            break;
          case 9:
            return this.statuColors[4].name;
            break;
        }
      };
    },
    showRepairsMalfunctionType(malfunctionType) {
      return function (malfunctionType) {
        return malfunctionType
          .map((res) => {
            return res.malfunctionTypeName;
          })
          .join(",");
      };
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    //查询报修记录
    async getRoomRepairs(data) {
      let res = await this.$store.dispatch("getRoomRepairs", data);
      if (res.success) {
        this.initData.repairList = res.data.map((res) => {
          res.repairsTime = dayjs(res.repairsTime).format("YYYY-MM-DD HH:mm");
          return res;
        });
      } else {
        Toast.fail(res.msg);
      }
      return res;
    },
    toRepairDetail(id, room, question, time, status) {
      let repair = {
        id,
        room,
        question,
        time,
        status,
      };
      this.$router.push({
        path: "/repaircomment",
        query: {
          repair: JSON.stringify(repair),
        },
      });
    },
    async onRefresh() {
      let res = await this.getRoomRepairs().catch((err) => {
        this.isLoading = false;
      });
      this.isLoading = false;
      if (res.success) {
        Toast("刷新成功!");
      } else {
        Toast.fail("刷新失败!");
      }
    },
  },
  mounted() {
    this.getRoomRepairs();
  },
};
</script>

<style scoped>
.container {
  height: 100vh !important;
  /* width: 100vw !important; */
  overflow-y: scroll !important;
  padding: 0 20px;
  /* background-color: WhiteSmoke; */
}

.van-nav-bar {
  background: #ba3939;
}

.nav-placeholder {
  height: 92px;
}

.msg-item {
  height: fit-content;
  width: 100%;
  margin: 50px 0px;
}

.msg-item-head,
.msg-item-box {
  border-radius: 10px;
  border: 1px Gainsboro solid;
}

.msg-item-box {
  box-sizing: border-box;
  height: fit-content;
  margin-top: 4px;
  width: 100%;
  /* background-color: white; */
  /* z-index: 999 !important; */
}

.msg-item-head {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.msg-item-room {
  font-size: 32px;
  font-weight: bold;
}

.msg-item-head {
  background-color: WhiteSmoke;
}

.msg-item-body {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0;
}

.msg-item-body-phenomenon,
.msg-item-body-question,
.msg-item-body-date {
  height: 70px;
  line-height: 70px;
  padding: 0 32px;
  font-size: 30px;
}
.msg-item-body-btn {
  height: 70px;
  line-height: 70px;
  padding-left: 30px;
  font-size: 30px;
}
.msg-item-body-comment {
  height: fit-content;
  padding: 0 32px;
  font-size: 30px;
}
.msg-item-body-q {
  display: flex;
  height: fit-content;
  padding: 0 32px;
  font-size: 30px;
}
.msg-item-body-q-left {
  display: inline-block;

  min-width: fit-content;
}
.msg-item-body-q-right {
  display: inline-block;
}
.tips_null {
  text-align: center;
  height: 100px;
  line-height: 100px;
  font-size: 28px;
  color: #969799;
  /* border: 1px red solid; */
}
</style>
